import React, { Component } from 'react';
import { Button, Table, Jumbotron, Container, Row, Col, OverlayTrigger, Tooltip, Form, Modal } from 'react-bootstrap';
import Auth from '../../middleware/auth';
import funciones from '../../middleware/funciones';
import Menu from '../menu';
import config from '../../config';
import { saveAs } from 'file-saver';
import Spinner from '../subcomponent/spinner';
import Modalobs from '../subcomponent/modalObservacion';
import { images } from '../../constants/images';

class GestionesEmpleados extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const currentUserType = sessionStorage.getItem('tipo');
    const state = Auth.isAuthenticated();
    const today = new Date();
    //const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    // const todayFormat = yyyy + "-" + mm + "-" + dd;
    const periodo = yyyy + mm;

    this.state = {
      documentos: [],
      docPendientes: [],
      docProceso: [],
      docToSend: [],
      resoluciones: [],
      empresa: currentCompany,
      tipo: currentUserType,
      isLogin: state,
      periodo,
      numero_inicial: "",
      numero_final: "",
      searchTipo: "",
      searchPeriodo: "",
      searchNumero: "",
      searchCliente: "",
      searchTransaccion: "",
      fecha_inicial: "",
      fecha_final: "",
      searchEstado: "",
      loading: false,
      visObsPDF: false,
      listAllPDF: 0,
      historial: false
    };
  }

  componentDidMount() {
    const { empresa } = this.state
    const { tipo } = this.state
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/resoluciones/', datasend)
      .then(res => res.json())
      .then((data) => {
        this.setState({ resoluciones: data });

      })
      .catch((error) => console.error(error))
  };

  updateInfo = ({ target }, showspinner) => {
    if (target) target.disabled = true;
    //console.log(showspinner);
    if (showspinner) this.setState({ loading: true });
    const { empresa } = this.state
    const { tipo } = this.state
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial_nom: this.state.numero_inicial,
      numero_final_nom: this.state.numero_final,
      periodo: this.state.periodo,
      estado: "0,1,2,3,4"
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/payroll/', datasend)
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          const datos = data.data;
          console.log(datos)

          this.setState({ documentos: datos, loading: false });
          this.reconteo();
        } else {
          if (data.code === "0000") this.setState({ documentos: [], loading: false });
        }
        if (target) target.disabled = false;
        // setTimeout(() => { this.updateInfo({ target }, false) }, 30000);
      })
      .catch((error) => console.error(error));
  }

  onePdf = ({ target }) => {
    target.disabled = true;
    if (this.state.listAllPDF >= 100) {
      this.setState({ visObsPDF: true });
    } else {
      this.setState({ loading: true });
    }
    const { empresa, historial } = this.state;
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      periodo: this.state.periodo,
      tipopdf: 1
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': (historial) ? '3' : '1'
      }
    };
    fetch(config.servBackEnd + '/files/getonepdf', datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, "facturas.pdf");
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
        this.setState({ loading: false });
      })
  }

  buscar = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  getPDF = ({ target }, doc) => {
    target.disabled = true;
    const { empresa } = this.state;

    const id = doc.ID_CABECERA_NOMINA;
    const tipo = doc.TIPO_DOCUMENTO_NOMINA;
    const numero = doc.NUMERO_DOCUMENTO_NOMINA;
    const nombreArchivo = tipo + '-' + numero + '.pdf';

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'blob',
        'empresa': empresa,
        'hist': '5'
      }
    }
    fetch(config.servBackEnd + '/files/getpdfnomina/' + id, datasend)
      .then((res) => {
        //console.log(res);
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, nombreArchivo);
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
      })
  };

  mailerDoc = (e, doc) => {
    const { target } = e;
    target.disabled = true;
    const { empresa } = this.state;

    if (doc.ID_CABECERA_NOMINA) {
      const docSend = [{
        ID_FACTURA: doc.ID_CABECERA_NOMINA
      }]
      const datasend = {
        method: 'POST',
        body: JSON.stringify(docSend),
        headers: {
          'Content-Type': 'application/json',
          'empresa': empresa,
          'hist': '5'
        }
      }
      fetch(config.servBackEnd + '/files/createsendnomina/', datasend)
        .then(res => res.json())
        .then((data) => {
          let tmpDocumentos = this.state.documentos;
            for (let index = 0; index < tmpDocumentos.length; index++) {
              const elementDoc = tmpDocumentos[index];
              if (elementDoc.ID_CABECERA_NOMINA.toString() === data.ID_FACTURA.toString()) {
                elementDoc.DOCUMENTO_ENVIADO = data.estado;
                elementDoc.DOCUMENTO_ENVIADO_OBSERVACION = data.mensaje;
                break;
              }
          };
          target.disabled = false;
          this.setState({ documentos: tmpDocumentos });
          this.reconteo();
          //if(!historial) this.updateInfo({});
        })
        .catch((error) => console.error(error))
    } else {
      //console.log("sin documentos pendientes por enviar");
      target.disabled = false;
      this.setState({ loading: false });
    }
  };

  reconteo = () => {
    const datos = this.state.documentos;
    let tmpDocPend = [];
    let tmpDocProc = [];
    let tmpDocSend = [];
    let allPdf = 0;
    datos.forEach(element => {
      if (element.DOCUMENTO_ENVIADO === "0") {
        tmpDocPend.push({
          ID_FACTURA: element.ID_FACTURA
        });
      }
      if (element.DOCUMENTO_ENVIADO === "1") {
        tmpDocProc.push({
          ID_FACTURA: element.ID_FACTURA
        });
      }
      if (element.DOCUMENTO_ENVIADO === "2") {
        tmpDocSend.push({
          ID_FACTURA: element.ID_FACTURA
        });
      }

      if (element.DOCUMENTO_ENVIADO === "2" || element.DOCUMENTO_ENVIADO === "4") {
        allPdf += 1;
      }
    });
    this.setState({ docPendientes: tmpDocPend, docProceso: tmpDocProc, docToSend: tmpDocSend, loading: false, listAllPDF: allPdf });
  };

  render() {
    //variables
    const docnomina = this.state.documentos;
    const validacionUser = this.state.isLogin;
    const { searchTipo } = this.state;
    const { searchNumero } = this.state;
    const { searchCliente } = this.state;
    const { searchTransaccion } = this.state;
    const { searchEstado, searchPeriodo } = this.state;
    const { loading } = this.state;
    const { historial } = this.state;
    //const numbertosend = (this.state.docToSend.length > 10) ? 10 : this.state.docToSend.length;
    //funciones
    const mailerDoc = this.mailerDoc;
    const updateInfo = this.updateInfo;
    //const onePdf = this.onePdf;
    const getPDF = this.getPDF;
    //const getXML = this.getXML;
    return (
      <div className="Menu">
        <Menu></Menu>
        <Jumbotron className="Jumbotron">
          {!historial && <h2>Gestión de documentos nómina</h2>}
          {historial && <h2>Historico de gestion</h2>}
        </Jumbotron>
        {!validacionUser && <p>La sesion se ha cerrado por favor ingrese de nuevo</p>}
        {validacionUser &&
          <div>
            <Container fluid>
              <Row className="justify-content-md-center" >
                <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>PERIODO</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="text" onChange={e => this.setState({ periodo: e.target.value })} value={this.state.periodo} >
                  </Form.Control>
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO INICIAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_inicial: e.target.value })} value={this.state.numero_inicial} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO FINAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_final: e.target.value })} value={this.state.numero_final} />
                </Col>
                {historial &&
                  <Col className="mb-2" xs={12} lg={2}>
                    <Button onClick={() => this.setState({ historial: false, documentos: [] })}  >Volver Gestion</Button>
                  </Col>
                }
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" name="actualizar" onClick={(e) => updateInfo(e, true)}  >Actualizar Documentos </Button>
                </Col>
                {/* <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" disabled={docnomina.length === 0} name="actualizar" onClick={onePdf}  >Generar PDF</Button>
                </Col> */}
              </Row>
              {/* false &&
              <Row className="justify-content-md-center">
                <Col className="mb-2" xs={12} lg="2"><Button id="enviarTodo" name="enviarTodo" onClick={enviarDoc}  >Cargar DIAN todos
                  <Badge className="ml-1" variant="light">{this.state.docPendientes.length}</Badge>
                  <span className="sr-only">unread messages</span></Button>
                </Col>
                <Col className="mb-2" xs={12} lg="2">
                  <Button id="confirmarTodo" name="confirmarTodo" onClick={salidaDoc}  >Confirmar todos
                  <Badge className="ml-1" variant="light">{this.state.docProceso.length}</Badge>
                  </Button>
                </Col>
              </Row> */
              }
              <Row>
                <Col>
                  <Table hover bordered responsive size="sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th><input type="text" maxLength="4" size="3" name="searchTipo" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="10" size="5" name="searchNumero" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="9" size="5" name="searchTransaccion" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="6" size="5" name="searchPeriodo" onChange={this.buscar} /></th>
                        <th></th>
                        {!historial && <th><select type="text" name="searchEstado" onChange={this.buscar} >
                          <option value="" defaultValue>Todos</option>
                          <option value="0">Sin Procesar</option>
                          <option value="1">pendiente DIAN</option>
                          <option value="2">Exitoso Dian</option>
                          <option value="3">Errores Dian</option>
                          {historial && <option value="4">Correo Enviado</option>}
                        </select>
                        </th>}
                      </tr>
                      <tr>
                        <th>Fecha Documento</th>
                        <th>Prefijo Dian</th>
                        <th>Numero Documento</th>
                        <th>Nombre Cliente</th>
                        <th>No Transaccion</th>
                        <th>Periodo</th>
                        <th>Valor</th>
                        <th>Estado</th>
                        <th>Observaciones</th>
                        <th colSpan="7">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(!loading && docnomina.length > 0) &&
                        docnomina.map(function (currentData, index) {
                          if (
                            currentData.TIPO_DOCUMENTO_NOMINA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                            && currentData.NUMERO_DOCUMENTO_NOMINA.toString().search(searchNumero.toLowerCase()) > -1
                            && currentData.NOMBRE_EMPLEADO.toLowerCase().search(searchCliente.toLowerCase()) > -1
                            && currentData.ID_TRANSACCION.toLowerCase().search(searchTransaccion.toLowerCase()) > -1 
                            && currentData.TELEFONO_EMPRESA.toLowerCase().search(searchPeriodo.toLowerCase()) > -1 
                            &&
                            (currentData.DOCUMENTO_ENVIADO.toLowerCase().search(searchEstado.toLowerCase()) > -1
                              || searchEstado === ""
                            )
                          ) {
                            return <tr name={index} key={index + "d0"}>
                              <td name="tipo" >{funciones.formatDate(currentData.FECHA_DOCUMENTO)}</td>
                              <td name="tipo" >{currentData.TIPO_DOCUMENTO_NOMINA}</td>
                              <td name="numero" >{currentData.NUMERO_DOCUMENTO_NOMINA}</td>
                              <td name="cliente" >{currentData.NOMBRE_EMPLEADO}</td>
                              <td name="transaccion" >{currentData.ID_TRANSACCION}</td>
                              <td name="periodo" >{currentData.TELEFONO_EMPRESA}</td>
                              <td name="periodo" >{currentData.COMPROBANTE_TOTAL}</td>
                              <td name="estado" >{funciones.textEstado(currentData.DOCUMENTO_ENVIADO)}</td>
                              <td name="estadoObservacion" ><Modalobs text={funciones.textCut(currentData.DOCUMENTO_ENVIADO_OBSERVACION)} descripcion={currentData.DOCUMENTO_ENVIADO_OBSERVACION} />  </td>
                              <OverlayTrigger placement='top' overlay={<Tooltip>Descargar Representacion Grafica</Tooltip>}>
                                <td ><Button className="buttonP" onClick={(e) => getPDF(e, currentData)} variant="outline-primary">
                                  <img src={images.pdf} alt="PDF" style={{ width: '70%', height: '70%' }} />
                                </Button></td>
                              </OverlayTrigger>
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Enviar Correo al empleado</Tooltip>}>
                                <td ><Button className="buttonE" onClick={(e) => mailerDoc(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4")} variant="outline-primary">
                                  <img src={images.enviar} alt="Enviar" style={{ width: '70%', height: '70%' }} />
                                </Button></td>
                              </OverlayTrigger>}
                              {/* <OverlayTrigger placement='top' overlay={<Tooltip>Descargar Representacion Grafica</Tooltip>}>
                                <td ><Button className="buttonP" onClick={(e) => getPDF(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Descargar XML Response</Tooltip>}>
                                <td ><Button className="buttonX1" onClick={(e) => getXML(e, currentData)} name="xml2" disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>}
                              <OverlayTrigger placement='top' overlay={<Tooltip>Descargar XML Attachment</Tooltip>}>
                                <td ><Button className="buttonx2" onClick={(e) => getXML(e, currentData)} name="xml1" disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>
                              {historial && <OverlayTrigger placement='top' overlay={<Tooltip>Enviar Correo al Cliente</Tooltip>}>
                                <td ><Button className="buttonE" onClick={(e) => mailerDoc(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>}
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Reprocesar</Tooltip>}>
                                <td >
                                  <Button 
                                    className="buttonR" 
                                    onClick={(e) => enviarDoc(e, currentData)} 
                                    name="reprocesar" 
                                    disabled={!((currentData.DOCUMENTO_ENVIADO === "3") || (currentData.DOCUMENTO_ENVIADO === "1" && currentData.ID_TRANSAC))}
                                    style={{ backgroundImage: `url(${images.reprocesar})` }}
                                  />
                                </td>
                              </OverlayTrigger>} */}
                              <td>
                                <Button 
                                  onClick={(e) => enviarDoc(e, currentData)} 
                                  name="reprocesar" 
                                  disabled={!((currentData.DOCUMENTO_ENVIADO === "3") || (currentData.DOCUMENTO_ENVIADO === "1" && currentData.ID_TRANSAC))}
                                  variant="outline-primary"
                                >
                                  <img src={images.reprocesar} alt="Reprocesar" style={{ width: '70%', height: '70%' }} />
                                </Button>
                              </td>
                            </tr>;
                          } else {
                            return null;
                          }
                        })}
                      {(!loading && docnomina.length === 0) &&
                        <tr>
                          <td colSpan="8"> CONSULTA SIN RESULTADOS </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  {(loading) && <Spinner loading={loading} />}
                </Col>
              </Row>
            </Container>
          </div>
        }
        <Modal
          show={this.state.visObsPDF}
          onHide={() => this.setState({ visObsPDF: false })}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              PDF EN PROCESO
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              EL PDF SE ESTA GENERANDO POR FAVOR NO RECARGAR LA PAGINA.
              <b>EL PDF SE DESCARGARA UNA VEZ ESTE LISTO</b>
            </p>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default (GestionesEmpleados);